import {createTheme} from '@mui/material/styles';
import {defaultThemeConfig} from './themeConfig';

export const defaultTheme = createTheme(defaultThemeConfig);

export type ThemeType = 'whiteTheme' | 'darkTheme' | 'greyTheme' | 'darkGreyTheme';
